<sdk-conversation-nav [darkMode]="true" [type]="conversationType"></sdk-conversation-nav>
